<template>
  <div class="flex-column h100">
    <navbar :title="title"></navbar>
    <div class="enterFactory flex1 flex-column">
      <el-card class="box-card mt10">
        <div class="inblock">
          <span class="demonstration">条形码 :</span>
          <el-input v-model="barCode" placeholder="条形码输入" @keyup.enter.native='outFactory'></el-input>
          <span class="ml10">
            <el-button type="primary" @click="outFactory">查询</el-button>
          </span>
          <span class="ml10">
            <el-button type="primary" @click="outSys">出厂</el-button>
          </span>
          <span class="ml10">
            <el-button type="primary" @click="delTableData()">取消物件</el-button>
          </span>
        </div>
      </el-card>
      <el-card class="box-card mt10">
        <div class="news">{{codeText}}</div>
      </el-card>
      <el-card class="box-card mt10 flex1">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :height="tableHeight"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
          @row-click="rowClick"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="订单号">
            <template slot-scope="scope">{{ scope.row.order_no }}</template>
          </el-table-column>
          <el-table-column prop="code_num" label="条形码"></el-table-column>
          <el-table-column prop="name" label="衣物名称"></el-table-column>
          <el-table-column prop="shopName" label="所属门店"></el-table-column>
          <el-table-column prop="create_time" label="时间"></el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card mt10">
        <div class="userDay">
          <span>工号:【{{operationRecord.job_number}}】</span>
          <span>姓名:【{{operationRecord.userName}}】</span>
          <span>今日计件:【{{operationRecord.countWork}}】</span>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import header from '@/components/header';
export default {
  components: {
    navbar: header
  },
  data() {
    return {
      tableHeight: window.innerHeight - 400,
      title: '发生未知错误',
      barCode: '',
      status: null,
      codeText: '系统准备完毕，请输入条形码!',
      operationRecord: {},
      tableData: [],
      multipleSelection: []
    }
  },
  created() {
    if (this.$route.query['title']) {
      this.title = this.$route.query['title']
    }
    if (this.$route.query['status']) {
      this.status = this.$route.query['status']
      this.countPosition()
    }
  },
  methods: {
    // 行的选中函数
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 把当前行的下表插入row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 点击行选中
    rowClick(row) {
      if (row !== null) {
        this.toggleSelection([this.tableData[row.index]])
      }
    },
    // 删除
    delTableData() {
      let newArr = [];
      this.tableData.map((v, i) => {
        let arr = this.multipleSelection.filter((n) => {
          return n.order_no == v.order_no
        })
        if (arr.length <= 0) {
          newArr.push(v)
        }
      })
      this.tableData = [...newArr]
    },
    // 出厂衣物扫描
    async outFactory() {
      let data = {
        barCode: this.barCode,
        status: parseInt(this.status)
      };
      let res = await this.$http.outFactory(data)
      if (res.data.data['0']) this.tableData.push(res.data.data['0']);
      this.codeText = res.data.msg
      if(res.data.data.isProcess == 2){
        this.$utils.voiceText('该物件已出厂');
        this.barCode = ''
        return
      }
      this.countPosition()
      if(res.data.status == 1){
        this.$utils.voiceText(res.data.data[0].voice_notification);
      }
      this.barCode = ''
    },
    // 今日操作记录
    async countPosition() {
      let res = await this.$http.countPosition(this.status)
      this.operationRecord = res.data.data
    },
    // 出厂
    async outSys() {
      let res = await this.$http.outSys()
      this.codeText = res.data.msg
    }
  }
}
</script>
<style lang="less" scoped>
.enterFactory {
  padding: 0 10px 30px 10px;
  .demonstration {
    margin-left: 5px;
    margin-right: 10px;
    font-size: 24px;
    font-weight: 700;
    color: #303133;
  }
  .el-input {
    width: auto;
  }
  .news {
    text-align: center;
    font-size: 20px;
    color: #f56c6c;
    letter-spacing: 4px;
  }
  .orderInfo {
    min-width: 300px;
    color: #04b84f;
    font-size: 20px;
    .text {
      max-width: 500px;
      margin-bottom: 20px;
      margin-right: 20px;
      display: flex;
      .name {
        width: 100px;
        text-align: right;
        margin-right: 10px;
      }
    }
  }
  .userDay {
    font-size: 20px;
    color: #303133;
    text-align: center;
    span {
      margin: 0 20px;
    }
  }
}
</style>